import { render, staticRenderFns } from "./UaBasins.vue?vue&type=template&id=06f6f25e&"
import script from "./UaBasins.vue?vue&type=script&lang=js&"
export * from "./UaBasins.vue?vue&type=script&lang=js&"
import style0 from "./UaBasins.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports